import React from "react";

import { Table, Space, Button, Modal, Typography, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../../PageHeader";
import Text from "antd/lib/typography/Text";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import AddRoles from "./AddRole";
import {
  getRolesPermissions,
  getRoles,
  AddRoles as AddRolesAction,
  deleteRole,
  DeleteRole,
  getSingleRoles,
} from "../../../../actions/companySettings";
import { hasAccess } from "../../../../utils";

const { Title } = Typography;

const columns = [
  {
    title: "Role Name",
    dataIndex: "role_name",
    key: "role_name",
    render: (text, data) => {
      return (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      );
    },
    //   render: text => <a href="/">{text}</a>,
  },
  {
    title: "Role Description",
    dataIndex: "description",
    key: "description",
  },
];

message.config({
  maxCount: 3,
});

const Roles = () => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [selectedRecord, setSelectedRecord] = React.useState({});
  const [permissionsData, setPermissionsData] = React.useState({});
  const [rolesData, setRolesData] = React.useState([]);
  const rolesPermissionResponse = useSelector(
    (state) => state.companySetting.getRolesPermissions || {},
  );
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {},
  );
  const addRolesResponse = useSelector(
    (state) => state.companySetting.addRoles || {},
  );

  const deleteRoleResponse = useSelector(
    (state) => state.companySetting.delete_role || {},
  );

  const tableAction = [
    hasAccess("users_and_controls", "write")
      ? {
          title: "Actions",
          key: "action",
          render: (text, record) =>
            record.role_name === "Admin"
              ? null
              : record.role_name !== "Employee" && (
                  <Space key={record.id} size="middle">
                    <button
                      onClick={(e) => {
                        showEditModal(record.id);
                        setSelectedRecord(record);
                        dispatch(
                          getRolesPermissions({
                            cc: record?.is_corporate_checker,
                          }),
                        );
                      }}
                    >
                      <img
                        src={EditIcon}
                        alt={"logo"}
                        className="action-logo"
                      />
                    </button>
                    {record.role_name !== "Employee" &&
                      record.role_name !== "Approver" && (
                        <button
                          onClick={(e) => {
                            showDeleteModal(record.id);
                          }}
                        >
                          <img
                            src={DeleteIcon}
                            alt={"logo"}
                            className="action-logo"
                          />
                        </button>
                      )}
                  </Space>
                ),
        }
      : {},
  ];

  React.useEffect(() => {
    dispatch(getRolesPermissions({}));
    dispatch(getRoles({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { permissions = {} } = {}, status = false } = {},
    } = rolesPermissionResponse;
    if (status) {
      setPermissionsData(permissions);
      if (selectedId) {
        dispatch(
          getSingleRoles({
            id: selectedId,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesPermissionResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      deleteRoleResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getRoles({}));
      dispatch({ type: DeleteRole.RESET });
    } else if (status === false) {
      dispatch({ type: DeleteRole.RESET });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteRoleResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      addRolesResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getRoles({}));
      dispatch({ type: AddRolesAction.RESET });
    } else if (status === false) {
      dispatch({ type: AddRolesAction.RESET });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addRolesResponse]);

  React.useEffect(() => {
    const { data: { response: { roles = {} } = {}, status = false } = {} } =
      rolesResponse;
    if (status) {
      setRolesData(roles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesResponse]);

  const showModal = () => {
    setSelectedId("");
    setSelectedRecord({});
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure about deleting this role?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() => dispatch(deleteRole({ id: selectedId }))}
          disabled={deleteRoleResponse?.loading}
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Role
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Role" : "New Role"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        destroyOnClose={true}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center"
          ? renderDeleteOption()
          : isModalVisible && (
              <AddRoles
                id={selectedId}
                selectedRecord={selectedRecord}
                handleCancel={handleCancel}
                permissionsData={JSON.parse(JSON.stringify(permissionsData))}
              />
            )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Roles & Permissions`}
          navigation={{
            Home: "/dashboard/",

            "Roles & Permissions": null,
          }}
        />
      </div>
      {hasAccess("users_and_controls", "write") && (
        <Button onClick={showModal} className="mb1 addNew primaryButton">
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo " />
          Add New Role
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={rolesData}
        className="settingsTable"
      />
    </>
  );
};

export default Roles;
